import Vue from 'vue'
const PGStorage = new Vue({
  data: {},
  methods: {
    getState (fieldName, defValue) {
      return this.getStorage(fieldName, defValue)
    }
    ,
    saveState (fieldName, data) {
      data = JSON.stringify(data)
      if (localStorage) {
        localStorage.setItem(fieldName, data)
      }
      // console.log('saveState', fieldName, data)
    },
    getStorage (fieldName, defValue) {
      var data = defValue
      if (localStorage) {
        data = localStorage.getItem(fieldName)
        if (!data) {
          data = defValue
        } else {
          try {
            data = JSON.parse(data)
          } catch (e) {
            data = defValue
          }

        }
      }
      // console.log('getState', fieldName, data)
      return data
    },
    clearState (fieldName) {
      if (localStorage) {
        localStorage.removeItem(fieldName)
      }
      console.log('clearState', fieldName)
    }
  }
})
export default PGStorage
